import client from "./client";

const homeworkApi = {
  list(params = {}) {
    return client.get("/homework", { params }).then((r) => r.data);
  },

  create(body) {
    return client.post("/homework", body).then((r) => r.data);
  },

  update(id, body) {
    return client.patch(`/homework/${id}`, body).then((r) => r.data);
  },

  remove(id) {
    return client.delete(`/homework/${id}`).then((r) => r.data);
  },
};

export default homeworkApi;
